import { useIntl } from 'react-intl';
import { FC } from 'react';
import { isEmpty } from 'lodash';

import { RecordDataItem, SearchInstanceDto } from '@app/components';

interface ContributorsSectionProps {
  contributors: SearchInstanceDto['contributors'];
  isPrimary?: boolean;
}

export const ContributorsSection: FC<ContributorsSectionProps> = ({
  contributors = [],
  children,
  isPrimary = false,
}) => {
  const { $t } = useIntl();

  if (isEmpty(contributors)) {
    return null;
  }

  const label = isPrimary
    ? $t({
        id: 'resultsList.by',
        defaultMessage: 'By:',
      })
    : $t({
        id: 'resultsList.contributors',
        defaultMessage: 'Contributors:',
      });

  return <RecordDataItem label={label}>{children}</RecordDataItem>;
};
